<h1 mat-dialog-title class="dialog-header">
  <div class="header-content">
    <span>OS: {{ data.card.osCode }}</span>
    <mat-icon class="ml-2" title="Ver detalhes" (click)="goToDetail(data.card.id)">visibility</mat-icon>
  </div>
</h1>
<div mat-dialog-content class="dialog-content">
  <h4 class="mt-2">Detalhes da OS</h4>
  <div class="d-flex space-x-2">
    <mat-form-field>
      <mat-label>Data de início</mat-label>
      <input matInput 
             [matDatepicker]="startDate" 
             [(ngModel)]="data.card.startDate" 
             name="startDate" 
             disabled>
      <mat-datepicker-toggle matIconSuffix [for]="startDate"></mat-datepicker-toggle>
      <mat-datepicker #startDate></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Data de entrega</mat-label>
      <input matInput 
             [matDatepicker]="dueDate" 
             [formControl]="dueDateFormControl"
             [min]="minDate">
      <mat-datepicker-toggle matIconSuffix [for]="dueDate"></mat-datepicker-toggle>
      <mat-datepicker #dueDate></mat-datepicker>
    </mat-form-field>
  </div>
  
  <div class="d-flex col-12">
    <mat-form-field class="w-100">
      <mat-label>Prioridade</mat-label>
      <mat-select [formControl]="priorityFormControl">
        @for (priority of priorityList; track priorityFormControl) {
          <mat-option [value]="priority">{{ priorityLabels[priority] }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  
  <div class="d-flex col-12">
    <mat-form-field class="w-100">
      <mat-label>Tags</mat-label>
      <mat-select [formControl]="tagsFormControl" multiple>
        @for (tag of tagList; track tagsFormControl) {
          <mat-option [value]="tag">{{ tag }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <h4 class="mt-2">Veículo</h4>
  <p><strong>Placa:</strong> {{ data.card.plate }}</p>
  <p><strong>Modelo:</strong> {{ data.card.vehicle }}</p>
  <h4 class="mt-4">Cliente</h4>
  <div *ngIf="client">
    <p><strong>Nome:</strong> {{ client.name }}</p>
    <p><strong>Telefone:</strong> {{ client.phone1 }}</p>
  </div>

</div>
<div mat-dialog-actions class="dialog-actions">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-flat-button color="primary" (click)="editInfoCard(data.card)">Salvar</button>
</div>
